export const riskListRoutes = {
  path: '',
  name: 'RiskList',
  component: () => import('@/views/risk/riskList/index.vue'),
  meta: {
    hidden: false,
    title: 'Risk list'
  }
}

export const riskDetailRoutes = {
  path: 'detail',
  name: 'RiskDetail',
  component: () => import('@/views/risk/riskDetail/index.vue'),
  meta: {
    hidden: false,
    title: 'User Limit Detail',
    activeMenu: '/risk'
  }
}

export const riskAddRoutes = {
  path: 'add',
  name: 'RiskAdd',
  component: () => import('@/views/risk/riskModify/index.vue'),
  meta: {
    hidden: false,
    title: 'Add User Limit',
    activeMenu: '/risk'
  }
}

export const riskModifyRoutes = {
  path: 'modify',
  name: 'RiskModify',
  component: () => import('@/views/risk/riskModify/index.vue'),
  meta: {
    hidden: false,
    title: 'Modify User Limit',
    activeMenu: '/risk'
  }
}

export const riskHistoryRoutes = {
  path: 'history',
  name: 'RiskHistory',
  component: () => import('@/views/risk/history/index.vue'),
  meta: {
    hidden: false,
    title: 'RiskHistory',
    activeMenu: '/risk'
  }
}

